/**
 * @generated SignedSource<<cdcc0b7790af6c0819c75d9a647b199b>>
 * @relayHash 4811a5c342533b21d8dd3e696c5fe3f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SiteConfigurationQuery$variables = Record<PropertyKey, never>;
export type SiteConfigurationQuery$data = {
  readonly siteSettings: {
    readonly companyHubName: string | null | undefined;
    readonly frontCover: {
      readonly frontCoverState: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SiteConfigurationQuery = {
  response: SiteConfigurationQuery$data;
  variables: SiteConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "companyHubName"
      },
      {
        "concreteType": "FrontCover",
        "kind": "LinkedField",
        "name": "frontCover",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "frontCoverState"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SiteConfigurationQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SiteConfigurationQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4811a5c342533b21d8dd3e696c5fe3f8",
    "id": "4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8",
    "metadata": {},
    "name": "SiteConfigurationQuery",
    "operationKind": "query",
    "text": "query SiteConfigurationQuery{siteSettings{companyHubName,frontCover{frontCoverState}}}"
  }
};
})();

(node as any).hash = "b4b2ce4fdc75a41f2f68ef6d954513ab";

export default node;
